module.exports = __webpack_public_path__ + "static/img/img3.7331489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/index/img3.png
// module id = 15Wn
// module chunks = 3